import { SearchInvoiceReportsCsvEncode } from '@/context/services/invoice_reports/InvoiceReportExport.service';
import { useTranslation } from '@/i18n';
import type { ActionMenuItems } from '@moneyforward/ap-frontend-components';
import { useMemo } from 'react';
import { MenuItem } from './MenuItem';

type ItemArgs = {
  onExport: (type: SearchInvoiceReportsCsvEncode) => () => void;
};

export const useItems = ({ onExport }: ItemArgs): ActionMenuItems => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        key: '1',
        label: (
          <MenuItem
            label='UTF-8 （BOM付）'
            tooltip={t('invoice_reports.export.utf-8.tooltip')}
          />
        ),
        onClick: onExport(SearchInvoiceReportsCsvEncode['utf-8']),
      },
      {
        key: '2',
        label: (
          <MenuItem
            label='Shift-JIS'
            tooltip={t('invoice_reports.export.shift-jis.tooltip')}
          />
        ),
        onClick: onExport(SearchInvoiceReportsCsvEncode['shift_jis']),
      },
    ],
    [onExport, t]
  );
};
